/*
 * @Author: yongsheng.zhang 
 * @Date: 2017-10-18 11:21:06 
 * @Last Modified by: yongsheng.zhang
 * @Last Modified time: 2017-10-20 16:47:48
 * 热门商区打点
 */
const $ = require('jquery')
const LXBid = require('../../../lib/lx-bid.js')
const LXWrap = require('../../../lib/lx.js')

const hotCataLx = () => {
    // 热门分类曝光
    LXWrap($('.cata-hot-info'), LXBid.hotViewBid, true, true)
    LXWrap($('.cata-hot-area'), LXBid.hotViewBid, true, true)
    LXWrap($('.cata-hot-metro'), LXBid.hotViewBid, true, true)
    // LXWrap($('.cata-hot-info a'), LXBid.hotViewBid, true, true)
    // LXWrap($('.cata-hot-area a'), LXBid.hotViewBid, true, true)
    // LXWrap($('.cata-hot-metro a'), LXBid.hotViewBid, true, true)
    // 热门分类点击打点 标题
    LXWrap($('.hot-title-link'), LXBid.hotClickBid, true, false)
    // 热门分类点击打点 每一项
    LXWrap($('.hot-item a'), LXBid.hotClickBid, true, false)
}

module.exports = hotCataLx



// WEBPACK FOOTER //
// ./src/pages/index/component/hot-cata.js